import React from 'react'
import clsx from 'clsx'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import Text from 'core/elements/Text'
import Theme from 'core/themes/model'
import colors from 'core/themes/base/colors'
import EllipsisText from 'k8s/components/common/EllipsisText'

type InfoBoxProps = {
  label: string
  value: string
  showDivider?: boolean
  imagePath?: string
  isCompact?: boolean
}

const useStyles = makeStyles<Theme>((theme) => ({
  subContainer: {
    display: 'flex',
    gap: 16,
    alignItems: 'center',
  },
  checkContainer: {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
  },
  contentContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  contentContainerVertical: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
  },
  content: {
    display: 'grid',
  },
  contentVertical: {
    display: 'grid',
    placeItems: 'center',
  },
  divider: {
    width: 1,
    height: 20,
    background: colors.grey[200],
    margin: theme.spacing(0, 2),
  },
  iconWrapper: {
    maxHeight: 32,
    maxWidth: 32,
  },
}))

const InfoBox: React.FC<InfoBoxProps> = ({
  label,
  value,
  showDivider = false,
  imagePath,
  isCompact = false,
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const isBelow1800 = useMediaQuery('(max-width:1800px)')

  return (
    <>
      <div
        className={clsx(
          classes.contentContainer,
          isBelow1800 && isCompact && classes.contentContainerVertical,
        )}
      >
        {imagePath && <img className={classes.iconWrapper} alt={label} src={imagePath} />}
        <div className={clsx(classes.content, isBelow1800 && isCompact && classes.contentVertical)}>
          <EllipsisText
            title={value}
            showTooltip={true}
            maxWidth={isBelow1800 ? 200 : undefined}
            variant="caption1"
          >
            {value}
          </EllipsisText>
          <Text variant="body2">{label}</Text>
        </div>
      </div>
      {showDivider && <div className={clsx(classes.divider, classes.subContainer)} />}
    </>
  )
}

export default InfoBox
